<template>
		<div class="pt-3 pb-3">
			<div class="text-center"  v-if="popupBatchUpdate.isLoading">
				<img src="@/assets/loading-logo-animation.gif" style="width: 75px"/>
				
				<p class="font-weight-bold">{{$t('THE_SYSTEM_IS_LOADING')}}</p>
			</div>
			<div v-else>
				<span class="font-italic mx-3">{{$t("UNDERSELL_LIMIT_TITLE")}}</span>
                <div class="d-flex justify-content-between mx-3">
                    <v-radio-group
                    v-model="updateOpts"
                    row
                    >
                        <v-radio :label="$t('FAST_UPDATE')" value="1" name="updateOpts"></v-radio>
                        <v-radio :label="$t('RESTRICTION_BULK_UPDATE')" value="2" name="updateOpts"></v-radio>
						<v-radio :label="$t('RESTRICTION_BULK_DELETE')" value="3" name="updateOpts"></v-radio>
                    </v-radio-group>
                    <v-btn color="primary" @click="saveUpdate()">
                        <template>{{ $t("UPDATE") }}</template>
                    </v-btn>
			    </div>
				<v-row class="m-0">
					<v-col sm="6">
						<label class="pb-1">{{ $t("ROOM_TYPE") }} *</label>
						<v-autocomplete
							@change="changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)"
							item-text="text"
							item-value="value"
							:items="listRoom"
							v-model="popupBatchUpdate.stopSell.roomSelect"
							outlined
							chips
							dense
							multiple
							>
							<template v-slot:prepend-item>
								<p class="mx-3 mt-1"> <a
								class="text-primary"
								@click="popupBatchUpdate.stopSell.roomSelect = listRoom.map(e => e.value); changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)"
								>{{$t('SELECT_ALL')}}</a> | <a
								class="text-primary"
								@click="popupBatchUpdate.stopSell.roomSelect = []; changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)"
								>{{$t('UN_SELECT_ALL')}}</a>
								</p>
							</template>
							<template v-slot:selection="{ item, index }">
								<v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
								:input-value="item.selected"
								close
								@click:close="removeChips(index, popupBatchUpdate.stopSell.roomSelect); changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)"
								@click="item.select; changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)">
								<span>{{ item.text }}</span>
								</v-chip>
								<span v-if="index === 2" class="grey--text caption"
								>(+{{ popupBatchUpdate.stopSell.roomSelect.length - 2 }})</span
								>
							</template>
							<template slot="no-data">
								<div class="no-data">{{ $t("NO_DATA") }}</div>
							</template>
						</v-autocomplete>
					</v-col>
					<v-col sm="6">
						<label class="pb-1"> {{
							$t("SALE_CHANNEL") }} *</label>
						<v-autocomplete item-text="text" item-value="value" :items="listOTA" v-model.lazy="popupBatchUpdate.stopSell.applyOTA" outlined
							chips dense multiple @change="changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)">
							<template v-slot:prepend-item>
								<p class="mx-3 mt-1"> <a class="text-primary" @click="popupBatchUpdate.stopSell.applyOTA = listOTA.map(e => e.value); changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)">{{
									$t('SELECT_ALL') }}</a> | <a class="text-primary" @click="popupBatchUpdate.stopSell.applyOTA = []; changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)">{{
									$t('UN_SELECT_ALL') }}</a>
								</p>
							</template>
							<template v-slot:selection="{ item, index }">
								<v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
									:input-value="item.selected" close @click:close="removeChips(index, popupBatchUpdate.stopSell.applyOTA); changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)"
									@click="item.select; changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)">
									<span>{{ item.text }}</span>
								</v-chip>
								<span v-if="index === 2" class="grey--text caption">(+{{ popupBatchUpdate.stopSell.applyOTA.length - 2 }})</span>
							</template>
							<template slot="no-data">
								<div class="no-data">{{ $t("NO_DATA") }}</div>
							</template>
						</v-autocomplete>
					</v-col>
				</v-row>
				<div class="w-100">
					<div class="d-sticky h-header-table d-flex">
						<div class="mr-auto d-flex align-items-center"> 	
							<div class="font-weight-bold text-primary px-3">
							</div>
						</div> 
						<div> 	
							<div class="small-gutters d-flex"> 	
								<div class="text-center font-weight-bold w-input-update" v-for="(item, key) in popupBatchUpdate.daysOfWeek" :key="key">{{ item.value }}</div> 	
							</div> 
						</div>
					</div>
					<template v-if="
					listRoom.filter(temp => popupBatchUpdate.stopSell.roomSelect.includes(temp.value)).length > 0 &&
					listOTA.filter(temp => popupBatchUpdate.stopSell.applyOTA.includes(temp.value)).length > 0
					">
						<div v-if="updateOpts == '1'">
							<div class="d-flex mt-2" v-for="(item, i) in popupBatchUpdate.stopSell.listOfPeriod" :key="i">
								<div class="mr-auto d-date d-flex align-items-center px-3">
									<date-picker :disabled-date="notBeforeToday" :confirm="true" :confirm-text="$t('CONFIRM')" :clearable="false"  
										:popup-class="'popup-calendar-desktop-detailhotel'" v-model="item.dateSelect" :lang="languageDate" :format="'DD/MM/YYYY'" 
										range placeholder="Select date range">
									</date-picker>
									<i v-if="popupBatchUpdate.stopSell.listOfPeriod.length > 1" class="icon-delete text-danger fs-16 ml-2 cursor" @click="removePeriodStopSell(item, i)"></i>
								</div>
								<div >
									<div class="small-gutters config-price">
										
										<v-btn color="primary" @click="copyRoomStopSell(item, i)" class="ml-1" :title="$t('COPY')" icon small><i class="icon-content_paste_go fs-16"></i></v-btn>
										<div
											class="w-input-update"
											v-for="(val, day) in item.value"
											:key="day"
										>
											<div
												v-if="listDisableDayRoomStopSell.length > 0 && listDisableDayRoomStopSell[i][day] && listDisableDayRoomStopSell[i][day].disable"
											>
												<b-form-input 
												class="w-input-update text-right rounded" 
												outlined 
												dense 
												disabled></b-form-input>
											</div>
											<div v-else class="vertical-divider border-0">
												<b-form-input 
												class="w-input-update text-right rounded" 
												@keyup="(e) => formatInput(e, day, item)"
												@input="(e) => formatInput(e, day, item)"
												outlined 
												dense 
												v-model="item.value[day]"
												></b-form-input>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="pt-2 pl-3">
								<v-btn color="primary" outlined  x-small @click="addDatePriodStopSell()">
									<v-icon color="#173d8f" small>add</v-icon>
									<label class="has-action fs-10">{{ $t("ADD_DATE_RANGE") }}</label>
								</v-btn>
							</div>
						</div>
						<div v-else>
							<template v-for="(room, roomIdx) in detailUpdateData">
								<div class="px-3 pt-2" :key="roomIdx">
									<span class="font-weight-bold text-primary">
										{{ room.roomName }}
									</span>
									<template v-for="(ota, otaIndex) in room.ota">
										<div class="mb-3" :key="otaIndex">
											<div class="d-flex justify-content-between pr-2">
												<span class="text-primary">
													{{ ota.otaName }}
												</span>
												<div class="ml-3 d-flex align-center">
													<v-btn color="primary" x-small class="ml-1" :title="$t('COPY')"
														@click="copyMaster(ota.dates)">
														<i class="icon-copy_all fs-16"></i>
													</v-btn>
													<v-btn color="primary" x-small class="ml-1" :title="$t('PASTE')"
														@click="pasteMaster(roomIdx, otaIndex)" v-if="objectCopy">
														<i class="icon-content_paste fs-16"></i>
													</v-btn>
												</div>
											</div>
											<div class="d-flex mt-2" v-for="(item, i) in ota.dates" :key="i">
												<div class="mr-auto d-date d-flex align-items-center">
													<template v-if="otaIndex === 0 && roomIdx === 0">
														<date-picker :disabled-date="notBeforeToday" :confirm="true" :confirm-text="$t('CONFIRM')" :clearable="false"  
															:popup-class="'popup-calendar-desktop-detailhotel'" v-model="item.dateSelect" :lang="languageDate" :format="'DD/MM/YYYY'" 
															range placeholder="Select date range" @change="dateDetailChangeDate(roomIdx,otaIndex, i)">
														</date-picker>
														<i v-if="ota.dates.length > 1" class="icon-delete text-danger fs-16 ml-2 cursor" @click="removePeriodStopSell(item, i)"></i>
													</template>
													<template v-else>
														{{ _moment(item.dateSelect[0]).format("DD/MM/YYYY") }} -
                        								{{ _moment(item.dateSelect[1]).format("DD/MM/YYYY") }}
													</template>
												</div>
												<div class="small-gutters config-price" v-for="(day, idx) in item.daysOfWeek" :key="idx">
													<v-btn v-if="idx == 0" color="primary" @click="copyRoomDetail(item.daysOfWeek)" class="ml-1" :title="$t('COPY')" icon small><i class="icon-content_paste_go fs-16"></i></v-btn>
													<div class="w-input-update" v-if="updateOpts == '2'">
														<div v-if="day.disable">
															<b-form-input class="w-input-update text-right rounded"  outlined dense disabled></b-form-input>
														</div>
														<div v-else class="vertical-divider border-0">
															<b-form-input 
															class="w-input-update text-right rounded" 
															@keyup="(e) => formatInput(e, day)"
															@input="(e) => formatInput(e, day)"
															outlined 
															dense 
															v-model="day.value"
															></b-form-input>
														</div>
													</div>
													<div class="w-input-update" v-else>
														<div class="vertical-divider border-0">
															<b-select 
																v-model="day.value" 
																:options="options" 
																:disabled="day.disable"
															></b-select>
														</div>
													</div>
												</div>
											</div>
											<div class="pt-2" v-if="otaIndex === 0 && roomIdx === 0">
												<v-btn color="primary" outlined  x-small @click="addDatePriodStopSell()">
													<v-icon color="#173d8f" small>add</v-icon>
													<label class="has-action fs-10">{{ $t("ADD_DATE_RANGE") }}</label>
												</v-btn>
											</div>
										</div>
									</template>
									<hr v-if="roomIdx <= detailUpdateData.length - 2" class="mb-0 mr-2" />
								</div>
							</template>
						</div>
					</template>
					<template v-else>
						<v-col class="text-center">
							<p style="color: #484646">{{ $t("NO_DATA") }}</p>
						</v-col>
					</template>
				</div>
			</div>
		</div>
</template>
<script>
import moment from "moment";
import { _alert } from "@/_helpers/function.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import { service } from "@/_services/SaleRoom/room-plan.service.js";
import { restriction } from "@/_services/SaleRoom/restriction.js";

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Input from "@/components/Utils/Input.vue";
export default {
	components: {
		"date-picker": DatePicker,
		 "input-text": Input,
	},
	data() {
		return {
			popupBatchUpdate: {
				isLoading: true,
				batchUpdateDialog: false,
				currentTabIndex: -1,
				currentRoomtypeIds: null,
				stopSell: {
					invalidDate: false,
					roomSelect: [],
					listOfPeriod: [],
					invalidDate: false,
					applyOTA: []
				},
				daysOfWeek: [
					{ code: "MON", value: this.$t("MONDAY") },
					{ code: "TUE", value: this.$t("TUESDAY") },
					{ code: "WED", value: this.$t("WEDNESDAY") },
					{ code: "THU", value: this.$t("THURSDAY") },
					{ code: "FRI", value: this.$t("FRIDAY") },
					{ code: "SAT", value: this.$t("SATURDAY") },
					{ code: "SUN", value: this.$t("SUNDAY") },
				],
				isChanged: 0
			},
			listRoom: [],
			systemLang: this.$i18n.locale,
			listDisableDayRoomStopSell: [],
			selectAllRoom: false,
			selectAllOta: false,
			updateOpts: "1",
			listOTA: [],
			detailUpdateData: [],
			objectCopy: null,
			options: [
				{ text: this.$t('NO'), value: null },
        		{ text: this.$t('DELETE'), value: -1 }
			]
		};
	},
	created() {
		this.initialize();
	},
	watch: {
		popupBatchUpdate: {
			handler(val) {
				this.listDisableDayRoomStopSell = [];
				val.stopSell.listOfPeriod.forEach((x, index) => {
					this.listDisableDayRoomStopSell.push({
						MON: {
							disable: true,
						},
						TUE: {
							disable: true,
						},
						WED: {
							disable: true,
						},
						THU: {
							disable: true,
						},
						FRI: {
							disable: true,
						},
						SAT: {
							disable: true,
						},
						SUN: {
							disable: true,
						},
					});
					
					var start = moment(x.dateSelect[0], "YYYY-MM-DD");
					var end = moment(x.dateSelect[1], "YYYY-MM-DD");
					let day = moment.duration(end.diff(start)).asDays();
					if (day < 6) {
						while (start <= end) {
							let daysOfWeek = this.formatDateOfWeek(start);
							this.listDisableDayRoomStopSell[index][daysOfWeek].disable = false;
							start = moment(start).add(1, "day");
						}
					} else {
						this.listDisableDayRoomStopSell[index].MON.disable = false;
						this.listDisableDayRoomStopSell[index].TUE.disable = false;
						this.listDisableDayRoomStopSell[index].WED.disable = false;
						this.listDisableDayRoomStopSell[index].THU.disable = false;
						this.listDisableDayRoomStopSell[index].FRI.disable = false;
						this.listDisableDayRoomStopSell[index].SAT.disable = false;
						this.listDisableDayRoomStopSell[index].SUN.disable = false;
					}
				});
				if (val.stopSell.roomSelect.length !== this.listRoom.length) {
                    this.selectAllRoom = false
                } else {
                     this.selectAllRoom = true
                }

				if (val.stopSell.applyOTA.length !== this.listOTA.length) {
                    this.selectAllOta = false
                } else {
                     this.selectAllOta = true
                }
				this.calculatorData();
			},
			deep: true,
		},
		updateOpts() {
			this.detailUpdateData.forEach((room) => {
				room.ota.forEach((row) => {
					row.dates.forEach((date) => {
						for (const day of date.daysOfWeek) {
							day.value = null;
						}
					});
				})
			});
			this.$forceUpdate();
		}
	},
	methods: {
		formatInput(event, day, item = null) {
			if (!item) {
				if(event.target) {
					let inputValue = event.target.value;
					inputValue = inputValue.replace(/\D/g, '');
					if (inputValue !== '0') {
					inputValue = inputValue.replace(/^0+/, '');
					}
					this.$set(day, "value", inputValue);
				}
			} else {
				const values = item.value;
				if (values && values.hasOwnProperty(day)) {
					if(event.target) {
						let dayValue = event.target.value;
						dayValue = dayValue.replace(/\D/g, '');
						if (dayValue !== '0') {
							dayValue = dayValue.replace(/^0+/, '');
						}
						this.$set(values, day, dayValue);
					}
				}
			}
			this.$forceUpdate();
		},
		changeRoomSelect() {
			this.calculatorData();
		},
		removeChips(index, arr) {
            if (index >= 0) arr.splice(index, 1);
			this.calculatorData();
        },
		calculatorData() {
			this.detailUpdateData = [];
			let tempData = this.popupBatchUpdate.stopSell.roomSelect.map((roomId) => {
				let roomRow = { id: roomId };
				let roomName = this.listRoom.filter((room) => room.value == roomId)[0].text || '';
				roomRow.roomName = roomName;
				let otaList = this.popupBatchUpdate.stopSell.applyOTA.map((otaId) => {
					let dates = [];
					this.popupBatchUpdate.stopSell.listOfPeriod.forEach((period) => {
						let daysOfWeek = [];
						let days = ['MON','TUE','WED','THU','FRI','SAT','SUN'];
						days.forEach((day) => {
							daysOfWeek.push({
								apply: null,
								value: null,
								day: day,
								disable: true
							});
						});

						let start = moment(period.dateSelect[0], "YYYY-MM-DD");
						let end = moment(period.dateSelect[1], "YYYY-MM-DD");
						let dayCount = moment.duration(end.diff(start)).asDays();

						if (dayCount < 6) {
							let currentDate = moment(start);
							while (currentDate <= end) {
								let currentDayOfWeek = currentDate.format('ddd').toUpperCase();
								let dayObject = daysOfWeek.find(d => d.day === currentDayOfWeek);

								if (dayObject) {
									dayObject.disable = false;
									dayObject.apply = currentDate.format("YYYY-MM-DD");
								}
								currentDate = moment(currentDate).add(1, 'day');
							}
						} else {
							let targetDay = moment(start);
							while (targetDay <= end) {
								let currentDayOfWeek = targetDay.format('ddd').toUpperCase();
								let dayObject = daysOfWeek.find(d => d.day === currentDayOfWeek);
								if (dayObject) {
									dayObject.disable = false;
								}
								targetDay.add(1, 'day');
							}
						}
						dates.push({ dateSelect: period.dateSelect, daysOfWeek: daysOfWeek, greaterThanAWeek: dayCount >= 6});
					});
					let otaName = this.listOTA.filter((ota) => ota.value == otaId)[0].text || '';
					return { id: otaId, dates: dates, otaName: otaName };
				});
				roomRow.ota = otaList;
				return roomRow;
			});
			this.detailUpdateData = tempData;
		},
        async getAllRoomDefault() {
            this.popupBatchUpdate.price.hasRoomRate = [];
            const roomRateUpdateStore = JSON.parse(localStorage.getItem("roomRateUpdate"));
            await restriction.getAllRoomTyeHasRoomRate().then(res => {
                if (res.responseCode == 0) {
                    let fromDateListOfPeriod = moment(this.currentDate).format(
                        "YYYY-MM-DD"
                    );
                    let toDateListOfPeriod = moment(this.currentDate)
                        .add(1, "day")
                        .format("YYYY-MM-DD");

                    this.planList = [];
                    res.data.forEach(x => {
                        var temp = {
                            roomTypeId: x.id,
                            romTypeNameI18ns: x.roomTypeI18n,
                            dates: [
                                {
                                    dateSelect: [
                                        new Date(fromDateListOfPeriod),
                                        new Date(toDateListOfPeriod)
                                    ],
                                    MON: {
                                        value: null,
                                        disable: true
                                    },
                                    TUE: {
                                        value: null,
                                        disable: true
                                    },
                                    WED: {
                                        value: null,
                                        disable: true
                                    },
                                    THU: {
                                        value: null,
                                        disable: true
                                    },
                                    FRI: {
                                        value: null,
                                        disable: true
                                    },
                                    SAT: {
                                        value: null,
                                        disable: true
                                    },
                                    SUN: {
                                        value: null,
                                        disable: true
                                    }
                                }
                            ],
                            multiplier: 1,
                            plus: 0,
                            selectAll: false
                        };
                        this.popupBatchUpdate.price.hasRoomRate.push(temp);
                    });
                    this.loadListRoom(res.data);
                    this.popupBatchUpdate.price.selectedRoomType = roomRateUpdateStore.roomId && roomRateUpdateStore.roomId != -1 ? [roomRateUpdateStore.roomId] 
                                                                    : roomRateUpdateStore.roomId && roomRateUpdateStore.roomId == -1 ? this.listRoom.map(e => e.value) : [];
                    this.panel = this.popupBatchUpdate.price.hasRoomRate.map((k, i) => i)
                }
            });
        },
        copyMaster(dates) {
			this.objectCopy = dates;
		},
		pasteMaster(roomIdx, otaIdx) {
			let room = this.detailUpdateData[roomIdx];
			room.ota[otaIdx].dates = JSON.parse(JSON.stringify(this.objectCopy));
		},
		dateDetailChangeDate(roomIdx, otaIdx, dateInx) {
			let dateChanged = this.detailUpdateData[roomIdx].ota[otaIdx].dates[dateInx].dateSelect;
			let oldDate = this.popupBatchUpdate.stopSell.listOfPeriod[dateInx].dateSelect;

			this.detailUpdateData[roomIdx].ota[otaIdx].dates[dateInx].dateSelect = oldDate;
			this.popupBatchUpdate.stopSell.listOfPeriod[dateInx].dateSelect = dateChanged;
		},
        formatDateOfWeek(date) {
            let dayOfWeek;
            switch (date.day()) {
                case 0: {
                    dayOfWeek = "SUN";
                    break;
                }
                case 1: {
                    dayOfWeek = "MON";
                    break;
                }
                case 2: {
                    dayOfWeek = "TUE";
                    break;
                }
                case 3: {
                    dayOfWeek = "WED";
                    break;
                }
                case 4: {
                    dayOfWeek = "THU";
                    break;
                }
                case 5: {
                    dayOfWeek = "FRI";
                    break;
                }
                case 6: {
                    dayOfWeek = "SAT";
                    break;
                }
            }
            return dayOfWeek;
        },
		checkAll(type, value) {
			this.popupBatchUpdate.stopSell[type] = [];
            if (value) {
				if (type === 'applyOTA') {
					this.listOTA.forEach(e => {
						this.popupBatchUpdate.stopSell.applyOTA.push(e.value);
					});
				} else {
					this.listRoom.forEach(e => {
						this.popupBatchUpdate.stopSell.roomSelect.push(e.value);
					});
				}
                
            } else {
				if (type === 'applyOTA') {
					this.popupBatchUpdate.stopSell.applyOTA = [];
				} else {
					this.popupBatchUpdate.stopSell.roomSelect = [];
				}
                
            }
			this.changeRoomSelect(this.popupBatchUpdate.stopSell.roomSelect);
		},
		async initialize() {
			this.objectCopy = null;
			this.popupBatchUpdate.isLoading = true;
			let fromDateListOfPeriod = moment(this.currentDate).format("YYYY-MM-DD");
			let toDateListOfPeriod = moment(this.currentDate)
				.add(1, "day")
				.format("YYYY-MM-DD");
			this.popupBatchUpdate.stopSell.listOfPeriod = [];
			this.popupBatchUpdate.stopSell.applyOTA = [];
			this.popupBatchUpdate.stopSell.listOfPeriod.push({
				id: this.popupBatchUpdate.stopSell.length + 1,
				dateSelect: [new Date(fromDateListOfPeriod), new Date(toDateListOfPeriod)],
				value: {
					MON: null,
					TUE: null,
					WED: null,
					THU: null,
					FRI: null,
					SAT: null,
					SUN: null,
				},
			});
			await syncota.getAllOTA({ keyword: "", status: 1 }).then((res) => {
				if (res.responseCode === 0) {
					this.listOTA = res.data.map((x) => {
						return {
							value: x.id,
							text: x.otaI18n.find((y) => y.lang == this.defaultI18n).name,
						};
					});
					this.listOTA = this.listOTA.filter((x) => x.value);
					const roomRateUpdateStore = JSON.parse(localStorage.getItem("roomRateUpdate"));
					if (roomRateUpdateStore.OtaId) {
						if (roomRateUpdateStore.OtaId == -1) {
							this.popupBatchUpdate.stopSell.applyOTA = this.listOTA.map(e => e.value);
						} else {
							this.popupBatchUpdate.stopSell.applyOTA = [roomRateUpdateStore.OtaId];
						}
					} else {
						this.popupBatchUpdate.stopSell.applyOTA.push(this.listOTA[0].value);
					}
					this.getAllRoomDefault();
				} else {
					_alert(res, this.$t(res.data), false);
				}
			});
		},
		async getAllRoomDefault() {
			await restriction.getAllRoomTyeHasRoomRate().then((res) => {
				if (res.responseCode == 0) {
					this.loadListRoom(res.data);
				}
			});
		},
		loadListRoom(data) {
            this.listRoom = [];
			this.popupBatchUpdate.stopSell.roomSelect = [];
            this.listRoom = this.listRoom.concat(
                data.map((room) => {
                    return {
                        value: room.id,
                        text: room.roomTypeI18n.find((x) => x.lang === this.defaultI18n).name,
                    };
                })
            );
			const params = JSON.parse(localStorage.getItem("roomRateUpdate"));
			if (params.roomId) {
				if (params.roomId != -1) {
					this.popupBatchUpdate.stopSell.roomSelect = [params.roomId];
				}
			} else {
				this.popupBatchUpdate.stopSell.roomSelect.push(this.listRoom[0].value);
			}
			this.popupBatchUpdate.isLoading = false;
        },
		copyRoomDetail(dayOfWeek) {
			let firstEnabledValue = null;
			let foundFirst = false;

			for (let item of dayOfWeek) {
				if (!item.disable) {
					if (!foundFirst) {
						firstEnabledValue = item.value;
						foundFirst = true;
						continue;
					}
					this.$set(item, 'value', firstEnabledValue);
				}
			}
		},
		copyRoomStopSell(item, i) {
			var updateTo = [];
			var first = false;
			var value = null;
			if (!this.listDisableDayRoomStopSell[i].MON.disable) {
				first = true;
				value = this.popupBatchUpdate.stopSell.listOfPeriod[i].value["MON"];
				updateTo.push("MON");
			}
			if (!this.listDisableDayRoomStopSell[i].TUE.disable) {
				if (!first) {
				first = true;
				value = this.popupBatchUpdate.stopSell.listOfPeriod[i].value["TUE"];
				}
				updateTo.push("TUE");
			}
			if (!this.listDisableDayRoomStopSell[i].WED.disable) {
				if (!first) {
				first = true;
				value = this.popupBatchUpdate.stopSell.listOfPeriod[i].value["WED"];
				}
				updateTo.push("WED");
			}
			if (!this.listDisableDayRoomStopSell[i].THU.disable) {
				if (!first) {
				first = true;
				value = this.popupBatchUpdate.stopSell.listOfPeriod[i].value["THU"];
				}
				updateTo.push("THU");
			}
			if (!this.listDisableDayRoomStopSell[i].FRI.disable) {
				if (!first) {
				first = true;
				value = this.popupBatchUpdate.stopSell.listOfPeriod[i].value["FRI"];
				}
				updateTo.push("FRI");
			}
			if (!this.listDisableDayRoomStopSell[i].SAT.disable) {
				if (!first) {
				first = true;
				value = this.popupBatchUpdate.stopSell.listOfPeriod[i].value["SAT"];
				}
				updateTo.push("SAT");
			}
			if (!this.listDisableDayRoomStopSell[i].SUN.disable) {
				if (!first) {
				first = true;
				value = this.popupBatchUpdate.stopSell.listOfPeriod[i].value["SUN"];
				}
				updateTo.push("SUN");
			}
			updateTo.forEach((x) => {
				this.popupBatchUpdate.stopSell.listOfPeriod[i].value[x] = value;
			});
		},
		saveUpdate() {
			if (this.updateOpts == "1") {
				this.confirmUpdateSellLimit();
			} 
			if (this.updateOpts == "2") {
				this.updateDetail();
			}
			if (this.updateOpts == "3") {
				this.deleteDetail();
			}
		},
		confirmUpdateSellLimit() {
			if (this.popupBatchUpdate.stopSell.roomSelect.length === 0 || this.popupBatchUpdate.stopSell.applyOTA.length === 0) {
				_alert("null", this.$t("PLEASE_COMPLETE_THE_FIELDS_MARKED"));
				return
			}
			let noted;
			let check = false
			this.popupBatchUpdate.stopSell.listOfPeriod.forEach((x) => {
				if (this.get_day_of_time(new Date(x.dateSelect[0]), new Date(x.dateSelect[1])) > 365) {
					_alert(null, this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR"));
					check = true;
					return true
				}
				if (!noted) {
					noted = moment(x.dateSelect[1], "YYYY/MM/DD");
					return true;
				}
				if (moment(x.dateSelect[0], "YYYY/MM/DD") <= noted) {
					check = true;
					_alert(null, this.$t("_BATCH_UPDATE.MESSAGE.OVERLAP_TIME"));
					this.popupBatchUpdate.stopSell.invalidDate = true;
				} else {
					noted = moment(x.dateSelect[1], "YYYY/MM/DD");
				}
			});
			let isBlank = true;
			var dateValue = [];
			this.popupBatchUpdate.stopSell.listOfPeriod.forEach((item) => {
				let fromDate = moment(item.dateSelect[0], "YYYY/MM/DD");
				let toDate = moment(item.dateSelect[1], "YYYY/MM/DD");
				while (fromDate <= toDate) {
					let daysOfWeek = this.formatDateOfWeek(fromDate);
					if (item.value[daysOfWeek]) {
						dateValue.push({
						apply: fromDate.format("YYYY-MM-DD"),
						value: item.value[daysOfWeek],
						});
						isBlank = false;
					}
					fromDate = moment(fromDate).add(1, "day");
				}
			});

			if (isBlank) {
				_alert(null, this.$t("DATA_BLANK"));
				check = true;
				return false;
			}

			let body = [];
			if (this.popupBatchUpdate.stopSell.roomSelect.length > 0 && dateValue.length > 0 && !check) {
				this.popupBatchUpdate.stopSell.roomSelect.forEach((x) => {
					body.push({
						id: x,
						dates: dateValue,
					});
				});
				this.popupBatchUpdate.isLoading = true;
				service
				.updateStopSell(body, this.popupBatchUpdate.stopSell.applyOTA)
				.then((res) => {
					_alert(res, this.$t(res.data), false);
				})
				.finally(
					() => (
					(this.popupBatchUpdate.isLoading = false)
					)
				);
			} else {
				_alert(null, this.$t("DATA_INPUT_INVALID"));
			}
		},
		isValidInteger(value) {
			if (typeof value === 'string' || typeof value === 'number') {
				const num = Number(value);
				return !isNaN(num) && Number.isInteger(num);
			}
			return false;
		},
		checkValidate() {
			let valid = true;
			let body = [];
			let message = '';
			
			if (this.popupBatchUpdate.stopSell.roomSelect.length === 0 || this.popupBatchUpdate.stopSell.applyOTA.length === 0) {
				valid = false;
				message = this.$t("PLEASE_COMPLETE_THE_FIELDS_MARKED");
				return {valid: valid, body: body, message: message}
			}
			let noted;
			this.popupBatchUpdate.stopSell.listOfPeriod.forEach((x) => {
				if (this.get_day_of_time(new Date(x.dateSelect[0]), new Date(x.dateSelect[1])) > 365) {
					valid = false;
					message = this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR");
					return true
				}
				if (!noted) {
					noted = moment(x.dateSelect[1], "YYYY/MM/DD");
					return true;
				}
				if (moment(x.dateSelect[0], "YYYY/MM/DD") <= noted) {
					valid = false;
					message = this.$t("_BATCH_UPDATE.MESSAGE.OVERLAP_TIME");
				} else {
					noted = moment(x.dateSelect[1], "YYYY/MM/DD");
				}
			});
			let isBlank = true;
			this.detailUpdateData.forEach((room) => {
				let roomSell = {
					id: room.id
				}
				let otaList = [];
				room.ota.forEach((row) => {
					let ota = {id: row.id};
					let dateList = [];
					row.dates.forEach((date) => {
						if (!date.greaterThanAWeek) {
							for (const day of date.daysOfWeek) {
								let dateRow = {};
								if (day.disable) {
									continue;
								}
								if (day.apply && this.isValidInteger(day.value)) {
									dateRow.apply = day.apply;
									dateRow.value = day.value;
									dateList.push(dateRow);
									isBlank = false;
								}
							}	
						} else {
							let start = moment(date.dateSelect[0], "YYYY-MM-DD");
							let end = moment(date.dateSelect[1], "YYYY-MM-DD");

							let targetDay = moment(start);
							while (targetDay <= end) {
								let dateRow = {};
								let currentDayOfWeek = targetDay.format('ddd').toUpperCase();
								let dayObject = date.daysOfWeek.find(d => d.day === currentDayOfWeek);
								if (dayObject && !dayObject.disable && this.isValidInteger(dayObject.value)) {
									dateRow.apply = targetDay.format("YYYY-MM-DD");
									dateRow.value = dayObject.value;
									isBlank = false;
									dateList.push(dateRow);
								}
								targetDay.add(1, 'day');
							}
						}
					});
					if (dateList.length > 0) {
						ota.dates = dateList;
						otaList.push(ota);
					}
				})
				if (otaList.length > 0) {
					roomSell.ota = otaList;
					body.push(roomSell);
				}
			})
			if (isBlank) {
				valid = false;
				message = this.$t("DATA_BLANK");
			}
			
			return {valid: valid, body: body, message: message}
		},
		updateDetail() {
			const response = this.checkValidate();
			if (!response.valid) {
				_alert("null", response.message);
				return
			}
			const body = response.body;
			this.popupBatchUpdate.isLoading = true;
			service.updateStopSellLimit(body)
			.then((res) => {
				_alert(res, this.$t(res.data), false);
			})
			.finally(
				() => (
				(this.popupBatchUpdate.isLoading = false)
				)
			);
		},
		deleteDetail() {
			const response = this.checkValidate();
			if (!response.valid) {
				_alert("null", response.message);
				return
			}
			const body = response.body;
			this.popupBatchUpdate.isLoading = true;
			service.deleteStopSellLimit(body)
			.then((res) => {
				_alert(res, this.$t(res.data), false);
			}).finally(
				() => (
				(this.popupBatchUpdate.isLoading = false)
				)
			);
		},
		addDatePriodStopSell() {
			let prevPeriod = this.popupBatchUpdate.stopSell.listOfPeriod[
				this.popupBatchUpdate.stopSell.listOfPeriod.length - 1
			];
			
			const tomorrow = new Date();
            tomorrow.setDate(new Date().getDate() + 365*2);
            if (new Date(moment(prevPeriod.dateSelect[1]).format("YYYY-MM-DD")) >= tomorrow) {
                return;
            }
			let from = moment(prevPeriod.dateSelect[1]).add(1, "day").format("YYYY-MM-DD");
			let to = moment(prevPeriod.dateSelect[1]).add(2, "day").format("YYYY-MM-DD");
			
			this.popupBatchUpdate.stopSell.listOfPeriod.push({
				id:
				this.popupBatchUpdate.stopSell.listOfPeriod[
					this.popupBatchUpdate.stopSell.listOfPeriod.length - 1
				].id + 1,
				dateSelect: [new Date(from), new Date(to)],
				value: {
					MON: null,
					TUE: null,
					WED: null,
					THU: null,
					FRI: null,
					SAT: null,
					SUN: null,
				},
			});
			this.calculatorData();
		},
		removePeriodStopSell(item, index) {
			this.popupBatchUpdate.stopSell.listOfPeriod.splice(index, 1);
		},
		_moment: moment,
	}
};
</script>